import { borderRadius, colors, fontSizes, fontWeights } from '@/theme'
import { Chip } from '@mui/material'
import DuplicateIcon from './icons/DuplicateIcon'

export default function PotentialDuplicateChip() {
  return (
    <Chip
      icon={<DuplicateIcon />}
      label='Potential duplicate'
      size='small'
      sx={{
        px: 1,
        py: 0.5,
        height: '24px',
        bgcolor: colors.status.infoLight,
        color: colors.status.info,
        border: `1px solid ${colors.status.infoBorder}`,
        borderRadius: borderRadius.lg,
        fontSize: fontSizes.sm,
        fontWeight: fontWeights.bold,
        '& .MuiChip-label': {
          p: 0,
          ml: 0.5
        },
        '& .MuiChip-icon': {
          ml: 0,
          mr: 0
        }
      }}
    />
  )
}
